import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { LETTERS } from "@/data/letters";

const fmt = (d) =>
  new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

export default function LettersTeaser() {
  const items = LETTERS.slice(0, 3);
  return (
    <section className="relative py-24 md:py-36 bg-paper" data-testid="letters-teaser-section">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
            <div>
              <p className="eyebrow mb-6">Kintsugi Letters</p>
              <h2 className="font-display text-ink font-medium leading-[1.1] text-4xl sm:text-5xl" data-testid="letters-teaser-heading">
                Short reflections, written slowly
              </h2>
            </div>
            <Link
              to="/letters"
              data-testid="letters-teaser-all-link"
              className="gold-underline-link text-[11px] uppercase tracking-[0.24em] text-gold shrink-0"
            >
              Read all letters
            </Link>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {items.map((l, i) => (
            <Reveal key={l.slug} delay={i * 0.07}>
              <Link
                to={`/letters/${l.slug}`}
                data-testid={`letter-teaser-${l.slug}`}
                className="group flex flex-col h-full border border-[rgba(169,129,47,0.26)] bg-canvas hover:border-gold transition-colors duration-500"
              >
                <div className="overflow-hidden">
                  <img
                    src={l.image}
                    alt={l.title}
                    loading="lazy"
                    className="w-full h-44 object-cover group-hover:scale-[1.04] transition-transform duration-[1400ms] ease-out"
                  />
                </div>
                <div className="p-7 flex flex-col flex-1">
                  <p className="text-[10px] uppercase tracking-[0.24em] text-inkdim mb-4">
                    {fmt(l.date)} · {l.read}
                  </p>
                  <h3 className="font-display text-2xl text-ink leading-snug group-hover:text-gold transition-colors duration-500">
                    {l.title}
                  </h3>
                  <p className="mt-3 text-inkdim text-sm leading-relaxed flex-1">{l.dek}</p>
                  <span className="inline-flex items-center gap-2 mt-6 text-[10px] uppercase tracking-[0.24em] text-gold group-hover:gap-3 transition-all duration-500">
                    Read <ArrowRight size={12} strokeWidth={1.5} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
